import { Component, computed, inject, input } from '@angular/core';
import { IonNav } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import {
	ModulesEnum,
	VehicleActionEnum,
	VehicleRecordDto,
	vehicleValidators,
} from '@splitsecondconnect/ultramarine-shared';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { UltraActionButtonComponent } from '../../../../../../shared/components/ultramarine-ui/ultra-action-button/ultra-action-button.component';
import { UltraIconComponent } from '../../../../../../shared/components/ultramarine-ui/ultra-icon/ultra-icon.component';
import { ActiveDirective } from '../../../../../../shared/directives/active.directive';
import { FocusDirective } from '../../../../../../shared/directives/focus.directive';
import { ModalService } from '../../../../../../shared/services/modals.service';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import { SellVehicleTaskComponent } from '../../../tasks/sell-vehicle-task/sell-vehicle-task.component';
import { UpdateOdometerTaskComponent } from '../../../tasks/update-odometer-task/update-odometer-task.component';

@Component({
	selector: 'app-vehicle-actions',
	templateUrl: 'vehicle-actions.component.html',
	imports: [
		SectionWrapperComponent,
		FocusDirective,
		ActiveDirective,
		UltraActionButtonComponent,
		TranslocoModule,
		UltraIconComponent,
	],
})
export class VehicleActionsComponent {
	nav = input<IonNav>();
	isEditMode = input<false>();
	#modalService = inject(ModalService);
	recordData = input<VehicleRecordModel>();

	options = computed(() => {
		const record = this.recordData();
		const recordDto = record as unknown as VehicleRecordDto;

		return [
			{
				title: 'vehicles|record-drawer|item-title|update-odometer',
				tooltip: `vehicles|record-drawer|item-tooltip|update-odometer`,
				type: 'basic',
				icon: 'swap_driving_apps_wheel',
				disabled: this.isEditMode(),
				function: () => {
					void this.#modalService.showActionModal(
						UpdateOdometerTaskComponent,
						record.id,
						ModulesEnum.VEHICLES,
						undefined,
						undefined,
						this.nav(),
					);
				},
			},
			{
				title: 'vehicles|record-drawer|item-title|sell-vehicle',
				tooltip: 'vehicles|record-drawer|item-tooltip|sell-vehicle',
				type: 'basic',
				icon: 'sell',
				disabled:
					this.isEditMode() ||
					!vehicleValidators.canPerformAction(recordDto, VehicleActionEnum.SELL)
						.isValid,
				function: () => {
					void this.#modalService.showActionModal(
						SellVehicleTaskComponent,
						record.id,
						ModulesEnum.VEHICLES,
						undefined,
						recordDto,
						this.nav(),
					);
				},
			},
		];
	});
}
